import { useCameraRecorderData } from "./cameraRecorderData";
import { Box } from "@mui/material";

const CameraRecorder = () => {
  const {
    videoRef,
    stopRecording,
    borderRadius,
    rectPos,
    rectSize,
    strokeWidth,
    dashArray,
    dashOffset,
  } = useCameraRecorderData();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        margin: "10px",
        position: "relative",
      }}
    >
      <div
        style={{
          width: "600px",
          maxWidth: "90vw",
          margin: "0 auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            position: "relative",
            width: "335px",
            height: "335px",
            margin: "0 auto",
            background: "#222",
            boxShadow: "0 0 16px 2px #3a5eff44",
            borderRadius: `${borderRadius}px`,
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <video
            ref={videoRef}
            style={{
              width: "100%",
              height: "100%",
              borderRadius: `${borderRadius}px`,
              background: "#000",
              display: "block",
              position: "absolute",
              zIndex: 2,
              objectFit: "cover",
            }}
            playsInline
            muted
          />
          <svg
            width="100%"
            height="100%"
            viewBox={`0 0 400 400`}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              pointerEvents: "none",
              zIndex: 9,
            }}
          >
            <rect
              x={rectPos}
              y={rectPos}
              width={rectSize}
              height={rectSize}
              rx={borderRadius}
              ry={borderRadius}
              fill="none"
              stroke="#50C878"
              strokeWidth={strokeWidth}
              strokeDasharray={dashArray}
              strokeDashoffset={dashOffset}
              style={{
                transition: "stroke-dashoffset 0.5s",
              }}
            />
          </svg>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          padding: 10,
        }}
      >
        <button
          style={{ fontSize: "0.8rem" }}
          className="btn gradient-btn-recorder mt-1"
          onClick={stopRecording}
        >
          Stop Recording
        </button>
      </div>
    </div>
  );
};

export default CameraRecorder;
